import { render, staticRenderFns } from "./UserProfilePicture.vue?vue&type=template&id=8e232fa2&scoped=true"
import script from "./UserProfilePicture.vue?vue&type=script&lang=js"
export * from "./UserProfilePicture.vue?vue&type=script&lang=js"
import style0 from "./UserProfilePicture.vue?vue&type=style&index=0&id=8e232fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e232fa2",
  null
  
)

export default component.exports